import { isDefined } from "@clipboard-health/util-ts";
import {
  type BasePillProps,
  DotSeparatedList,
  mergeSxProps,
  Pill,
  PillSkeleton,
} from "@src/appV2/redesign/system/ui-components";
import { isEmpty } from "lodash";

type VisitQualificationPillProps = Omit<BasePillProps, "iconType"> & {
  isLoading?: boolean;
  workerRequirement: string | undefined;
  specialties: string[];
};

function getPillLabelItems(workerRequirement: string | undefined, specialties: string[]) {
  const items: string[] = [];
  if (isDefined(workerRequirement)) {
    items.push(workerRequirement);
  }

  if (specialties.length === 1) {
    items.push(specialties[0]);
  } else if (specialties.length > 1) {
    items.push(`${specialties[0]}, + ${specialties.length - 1}`);
  }

  return items;
}

export function VisitQualificationPill(props: VisitQualificationPillProps) {
  const {
    workerRequirement,
    specialties,
    variant = "outlined",
    size = "small",
    sx,
    isLoading,
    ...pillProps
  } = props;

  if (isLoading) {
    return <PillSkeleton width="2rem" />;
  }

  if (!isDefined(workerRequirement) && isEmpty(specialties)) {
    return null;
  }

  return (
    <Pill
      size={size}
      label={
        <DotSeparatedList>{getPillLabelItems(workerRequirement, specialties)}</DotSeparatedList>
      }
      variant={variant}
      sx={mergeSxProps({ width: "fit-content" }, sx)}
      backgroundColor={(theme) => theme.palette.background.tertiary}
      {...pillProps}
    />
  );
}
